export class ActiveFilterValueConverter {
    
    toView(items, property: string, filterValue: boolean = true) {
        return items.filter((item) => (item[property]? item[property]: false) == (filterValue == null? true: filterValue));
    }
}